import React, { useState } from 'react';
import ApplicationForm from './ApplicationForm';

const Mentorship = () => {
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showFullTestimonialLuanne, setShowFullTestimonialLuanne] = useState(false);
  const [showFullTestimonialNauara, setShowFullTestimonialNauara] = useState(false);
  const [showFullTestimonialIsabella, setShowFullTestimonialIsabella] = useState(false);
  
  const handleOpenForm = () => {
    setShowApplicationForm(true);
  };
  
  const handleCloseForm = () => {
    setShowApplicationForm(false);
  };

  const handleOpenVideoModal = () => {
    setShowVideoModal(true);
  };

  const handleCloseVideoModal = () => {
    setShowVideoModal(false);
  };

  const toggleTestimonialLuanne = () => {
    setShowFullTestimonialLuanne(!showFullTestimonialLuanne);
  };

  const toggleTestimonialNauara = () => {
    setShowFullTestimonialNauara(!showFullTestimonialNauara);
  };

  const toggleTestimonialIsabella = () => {
    setShowFullTestimonialIsabella(!showFullTestimonialIsabella);
  };

  return (
    <section id="mentoria" className="py-16 bg-neutral-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-sans font-bold mb-2 text-primary">A Mentoria Médica</h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Uma experiência completa de aprendizado que combina teoria avançada e prática clínica real
          </p>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-8 mb-12">
          <div className="lg:w-1/2 bg-neutral-lightest p-8 rounded-lg shadow-medium">
            <h3 className="text-2xl font-sans font-bold mb-4 text-primary text-center md:text-left">Sobre a Mentoria</h3>
            
            <h3 className="text-xl font-sans font-semibold mb-2 text-primary text-center md:text-left">Nos próximos 6 meses vamos trabalhar juntos para desenvolver sua segurança e transformar sua carreira</h3>
            
            <p className="mb-4 text-gray-700 leading-relaxed text-center md:text-left">
              A Mentoria Médica do Dr. Guthyerres Carvalho é um programa exclusivo e imersivo desenvolvido para médicos que desejam aprofundar seus conhecimentos e habilidades nas áreas de emagrecimento e reposição hormonal. Diferente de cursos tradicionais, esta mentoria oferece uma experiência única que combina aulas teóricas aprofundadas com prática clínica supervisionada em consultório real.
            </p>
            
            <p className="mb-4 text-gray-700 leading-relaxed text-center md:text-left">
              <strong>Importante:</strong> Esta mentoria não é indicada para médicos que pretendem atender a preços populares ou planos de saúde. Nosso foco é na medicina de alta performance e resultados diferenciados.
            </p>
            
            <p className="mb-4 text-gray-700 leading-relaxed text-center md:text-left">
              Os participantes têm a oportunidade de acompanhar o Dr. Guthyerres em sua rotina clínica, observando de perto a aplicação prática dos protocolos de tratamento, a abordagem personalizada com cada paciente e as técnicas específicas utilizadas para casos complexos. Todos os protocolos, prescrições e condutas estarão completamente abertos e disponíveis para discussão.
            </p>
            
            <p className="mb-4 text-gray-700 leading-relaxed text-center md:text-left">
              Além da experiência prática, os médicos participantes recebem material didático exclusivo, têm acesso a estudos de caso detalhados e participam de discussões clínicas que ampliam significativamente sua capacidade de diagnóstico e tratamento. A mentoria é estruturada para garantir que cada participante saia apto a prescrever sem receio, com total segurança das condutas.
            </p>
          </div>
          
          <div className="lg:w-1/2 bg-neutral-lightest p-8 rounded-lg shadow-medium">
            <h3 className="text-2xl font-sans font-bold mb-4 text-secondary text-center md:text-left">Diferenciais da Mentoria</h3>
            
            <div className="mb-6">
              <h4 className="text-xl font-sans font-semibold mb-2 text-primary text-center md:text-left">Prática Real em Consultório</h4>
              <p className="text-gray-700 leading-relaxed text-center md:text-left">
                Nossa mentoria proporciona uma vivência clínica exclusiva: você acompanha atendimentos reais lado a lado com o Dr. Guthyerres, com total privacidade — apenas você, o paciente e o mentor — observando de perto a aplicação prática dos protocolos em casos complexos e variados com objetivo de te dar segurança para prescrição e precisão no manejo de terapias hormonais e implantes.
              </p>
            </div>
            
            <div className="mb-6">
              <h4 className="text-xl font-sans font-semibold mb-2 text-primary text-center md:text-left">Aulas Exclusivas e Personalizadas</h4>
              <p className="text-gray-700 leading-relaxed text-center md:text-left">
                O conteúdo teórico da mentoria é constantemente atualizado com as mais recentes evidências científicas e adaptado às necessidades específicas de cada turma. As aulas abordam desde os fundamentos fisiológicos até as técnicas mais avançadas de tratamento, sempre com foco na aplicabilidade clínica e nos resultados para os pacientes.
              </p>
            </div>
            
            <div className="mb-6">
              <h4 className="text-xl font-sans font-semibold mb-2 text-primary text-center md:text-left">Networking Profissional</h4>
              <p className="text-gray-700 leading-relaxed text-center md:text-left">
                A mentoria também proporciona uma valiosa oportunidade de networking com outros profissionais médicos interessados nas mesmas áreas de atuação. Esta rede de contatos frequentemente resulta em parcerias profissionais, troca de experiências e suporte contínuo mesmo após o término do programa.
              </p>
            </div>
            
            <div>
              <h4 className="text-xl font-sans font-semibold mb-2 text-primary text-center md:text-left">Suporte Contínuo</h4>
              <p className="text-gray-700 leading-relaxed text-center md:text-left">
                Suporte via WhatsApp e acesso a uma comunidade exclusiva de alunos para troca de experiências e dúvidas. Você nunca estará sozinho em sua jornada de aprendizado e aplicação dos conhecimentos adquiridos.
              </p>
            </div>
          </div>
        </div>

        {/* Quadro Comparativo */}
        <div className="mb-12">
          <h3 className="text-2xl font-sans font-bold mb-6 text-primary text-center">Essa mentoria...</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-functional-subtleGreen p-8 rounded-lg shadow-medium border border-functional-subtleGreen">
              <h4 className="text-xl font-sans font-semibold mb-4 text-functional-success text-center md:text-left">É para você se:</h4>
              <ul className="list-disc list-inside text-gray-700 space-y-2 text-center md:text-left">
                <li>Quer crescer na carreira</li>
                <li>Quer se tornar referência na área</li>
                <li>Quer entregar resultados consistentes com segurança e embasamento científico</li>
                <li>Quer viver do seu trabalho no consultório</li>
                <li>Quer deixar de dar plantões</li>
              </ul>
            </div>
            <div className="bg-functional-subtleRed p-8 rounded-lg shadow-medium border border-functional-subtleRed">
              <h4 className="text-xl font-sans font-semibold mb-4 text-functional-error text-center md:text-left">Não é para você se:</h4>
              <ul className="list-disc list-inside text-gray-700 space-y-2 text-center md:text-left">
                <li>Deseja trabalhar com planos de saúde</li>
                <li>Deseja atender por preços populares</li>
                <li>Deseja seguir protocolos prontos</li>
                <li>Coloca o faturamento acima do bem-estar do paciente</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="bg-neutral-lightest p-8 rounded-lg shadow-medium">
          <h3 className="text-2xl font-sans font-bold mb-6 text-primary text-center">Depoimentos de Médicos Participantes</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Depoimento da Dra. Luanne */}
            <div className="bg-neutral-light p-6 rounded-lg shadow-soft flex flex-col">
              <div className="flex items-center mb-4">
                <img 
                  src={require("../assets/images/testimonials/IMGDraLuane.jpg")} 
                  alt="Depoimento da Dra. Luanne Gerbassi" 
                  className="w-20 h-20 rounded-full object-cover mr-4 border-2 border-secondary"
                />
                <div>
                  <h4 className="text-lg font-sans font-semibold text-primary">Dra. Luanne Gerbassi</h4>
                  <p className="text-gray-600">Dermatologista</p>
                </div>
              </div>
              <div className="text-gray-700 space-y-3 text-center md:text-left flex-grow">
                <p>
                  "Não tenho o que falar, realmente foi um divisor pra mim e eu já via isso nas primeiras aulas (Graças a Deus por isso), posso falar por mim."
                </p>
                <p>
                  "Guthyerres conseguiu me fazer amar fisiologia, porque QUALQUER coisa que ele prescreve ele me mostra na fisiologia e não foi pq "falaram q deu certo"."
                </p>
                
                {showFullTestimonialLuanne && (
                  <>
                    <p>
                      "Hoje fica tudo muito claro pra mim, tanto do que fazer quanto do que não fazer, porque não teria sentido algum. Tudo clareia e você fica mais confiante do que está fazendo. É uma evolução, obvio. Vivo tirando dúvidas com ele, mas hoje estou MUITO mais segura."
                    </p>
                    <p>
                      "E assim, já falei isso pra ele, mas acho que vale falar aqui tb. To muito satisfeita em saber que meu dinheiro foi investido na pessoa certa (e meio que no escuro, pq me indicaram ele e apenas confiei rs)."
                    </p>
                    <p>
                      "Porque ao mesmo tempo que ele conversa comigo sobre faturamento, venda, ele não faz NADA passando por cima, enganando, ou enchendo linguiça pro paciente. Ele simplesmente faz porque que ele acredita que vai dar resultado. E DÁ! Fideliza o paciente pelo resultado."
                    </p>
                    <p>
                      "Se hoje ele fatura X, posso garantir que ele poderia estar faturando 5X, mas ele é honesto demais com o paciente pra isso e isso acalma meu coração."
                    </p>
                    <p>
                      "Enfim... não estou puxando saco, só dando meu feedback aqui pra vocês como uma pessoa que decidiu investir dinheiro nisso e que tá valendo MUITO A PENA."
                    </p>
                  </>
                )}
                
                <button 
                  onClick={toggleTestimonialLuanne}
                  className="text-secondary hover:text-secondary-light font-semibold mt-3"
                >
                  {showFullTestimonialLuanne ? 'Ler menos' : 'Ler mais'}
                </button>
              </div>
            </div>
            
            {/* Depoimento da Dra. Nauara com vídeo */}
            <div className="bg-neutral-light p-6 rounded-lg shadow-soft flex flex-col">
              <div className="flex items-center mb-4">
                <div className="relative w-20 h-20 mr-4">
                  <video 
                    src={require("../assets/videos/VideoDraNauara.MP4")} 
                    className="w-20 h-20 rounded-full object-cover border-2 border-secondary"
                    muted
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button 
                      onClick={handleOpenVideoModal}
                      className="bg-primary/80 hover:bg-primary text-white rounded-full p-2 transition-colors"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h1m4 0h1m6-6V7a2 2 0 00-2-2H5a2 2 0 00-2 2v3m2 4h10a2 2 0 002-2v-3a2 2 0 00-2-2H5a2 2 0 00-2 2v3z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg font-sans font-semibold text-primary">Dra. Nauara</h4>
                  <p className="text-gray-600">Cardiologista</p>
                </div>
              </div>
              <div className="text-gray-700 space-y-3 text-center md:text-left flex-grow">
                <button 
                  onClick={handleOpenVideoModal}
                  className="text-secondary hover:text-secondary-light font-semibold mb-3 block"
                >
                  📹 Assista ao vídeo
                </button>
                <p>
                  "A minha experiência com o Guthyerres foi extremamente positiva. Eu fiz a mentoria dele sobre implantes hormonais. Eu já havia feito outros cursos, mas tinha muita dúvida, muita insegurança."
                </p>
                <p>
                  "Ele solucionou todas as minhas dúvidas, teve bastante prática. Eu já terminei a mentoria dele atuando no meu consultório e implementando essa nova prática de implantes hormonais, o que mudou o perfil do meu consultório."
                </p>
                
                {showFullTestimonialNauara && (
                  <p>
                    "Eu tenho hoje um faturamento acima de 100 mil e era uma meta de vida. Hoje eu já tenho até outras metas, então fiquei extremamente satisfeita em ter feito a mentoria do Guthyerres e essa parceria que dá tão certo. Então eu oriento todo mundo a confiar no Guthyerres, que tem uma metodologia excelente para ensinar e muita paciência."
                  </p>
                )}
                
                <button 
                  onClick={toggleTestimonialNauara}
                  className="text-secondary hover:text-secondary-light font-semibold mt-3"
                >
                  {showFullTestimonialNauara ? 'Ler menos' : 'Ler mais'}
                </button>
              </div>
            </div>
            
            {/* Depoimento da Dra. Isabella */}
            <div className="bg-neutral-light p-6 rounded-lg shadow-soft flex flex-col">
              <div className="flex items-center mb-4">
                <img 
                  src={require("../assets/images/user-photos/nova_isabella.png")} 
                  alt="Depoimento da Dra. Isabella Sepulveda" 
                  className="w-20 h-20 rounded-full object-cover mr-4 border-2 border-secondary"
                />
                <div>
                  <h4 className="text-lg font-sans font-semibold text-primary">Dra. Isabella Sepulveda</h4>
                  <p className="text-gray-600">Pós graduada em endocrinologia</p>
                </div>
              </div>
              <div className="text-gray-700 space-y-3 text-center md:text-left flex-grow">
                <p>
                  "Conheço o Guth desde a escola e sempre admirei o quanto ele é estudioso, dedicado e comprometido com tudo o que faz. Quando me vi cheia de dúvidas em relação às terapias hormonais e aos implantes, sabia que precisava de alguém coerente, ético e com conhecimento de verdade — e imediatamente pensei nele."
                </p>
                <p>
                  "Foi a melhor decisão que eu poderia ter tomado. Desde que fiz a mentoria com o Guth, meu consultório evoluiu, minha carreira ganhou novos rumos e, mais do que isso, eu cresci como pessoa e como médica."
                </p>
                
                {showFullTestimonialIsabella && (
                  <>
                    <p>
                      "Pude oferecer o melhor para minhas pacientes, com mais segurança, embasamento e propósito. Sou eternamente grata por essa troca e por essa amizade que vem de tantos anos e que hoje também se traduz em admiração profissional."
                    </p>
                  </>
                )}
                
                <button 
                  onClick={toggleTestimonialIsabella}
                  className="text-secondary hover:text-secondary-light font-semibold mt-3"
                >
                  {showFullTestimonialIsabella ? 'Ler menos' : 'Ler mais'}
                </button>
              </div>
            </div>
          </div>
          
          <div className="bg-neutral-light p-6 rounded-lg shadow-soft mt-8">
            <h3 className="text-xl font-sans font-bold mb-4 text-primary text-center">Garantias e Benefícios Exclusivos</h3>
            
            <div className="mb-4 text-center">
              <p className="text-gray-700 font-semibold mb-2">Garantia de Satisfação</p>
              <p className="text-gray-700">Se você estiver acompanhando as aulas e não sentir que está sendo útil para seu desenvolvimento profissional, você tem direito a reembolso.</p>
            </div>
            
            <div className="mb-6 text-center">
              <p className="text-gray-700 font-semibold mb-2">Descontos Especiais</p>
              <p className="text-gray-700">Pacientes e ex-alunos têm desconto em novos cursos e programas oferecidos pelo Dr. Guthyerres Carvalho.</p>
            </div>
            
            <div className="text-center">
              <a 
                href="https://pt.surveymonkey.com/r/R7CD6CV"
                target="_blank" rel="noopener noreferrer"
                className="inline-block mt-4 bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
              >
                Quero participar da próxima turma
              </a>
            </div>
          </div>
          
          {showApplicationForm && <ApplicationForm onClose={handleCloseForm} />}
          
          {/* Modal do vídeo */}
          {showVideoModal && (
            <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden">
                <div className="p-4 border-b border-gray-200 flex justify-between items-center">
                  <h3 className="text-xl font-sans font-bold text-primary">Depoimento da Dra. Nauara - Cardiologista</h3>
                  <button 
                    onClick={handleCloseVideoModal}
                    className="text-gray-500 hover:text-gray-700 transition-colors"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <div className="p-4">
                  <video 
                    src={require("../assets/videos/VideoDraNauara.MP4")} 
                    className="w-full h-auto rounded-lg max-h-96"
                    controls
                    autoPlay
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Mentorship;

